module.exports = "/images/key.svg?941ccefdbe814354a17aa38ee76794c8";